export class Subscriber {
  name: string;
  birthday: Date;
  address: string;
  city: string;
  postCode: string;
  email: string;
  dontHaveEmail: boolean;
  phoneBookVisibility: PhoneBookVisibility;
}

// Order must match API
export enum PhoneBookVisibility {
  Unknown = 'Unknown',
  Visible = 'Visible',
  Hidden = 'Hidden',
  PartiallyHidden = 'PartiallyHidden',
}

export enum PhoneBookVisibilityText {
  Unknown = 'Ukjent',
  Visible = 'Synlig',
  Hidden = 'Skjult',
  PartiallyHidden = 'Skjult adresse',
}
